interface IconProps {
    size?: number;
}

export default function DefaultProviderIcon({ size = 16 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="#a1a1aa">
            <circle cx="12" cy="12" r="10" />
        </svg>
    );
}
